import { render, staticRenderFns } from "./GroupAndPersonWorkbench.vue?vue&type=template&id=582d53f8&scoped=true"
import script from "./GroupAndPersonWorkbench.vue?vue&type=script&lang=js"
export * from "./GroupAndPersonWorkbench.vue?vue&type=script&lang=js"
import style0 from "./GroupAndPersonWorkbench.vue?vue&type=style&index=0&id=582d53f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d53f8",
  null
  
)

export default component.exports